import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

// Feuille de partage système via le pont natif (ShareComponent) : contrairement
// à navigator.share, fonctionne aussi hors HTTPS (serveur local des builds Debug).
export default class extends BridgeComponent {
  static component = 'share'
  static values = { url: String, title: String }

  share() {
    this.send('share', { url: this.urlValue, title: this.titleValue })
  }
}
